import React from "react";
import {Button, Col, Input, Row, Select, Form} from "antd";
import BaseComponent from "../../../../redare/components/BaseComponent";
import UserPresenter from "../../.gen/presenter/component/core/UserPresenter";

export default class UserStatusForm extends BaseComponent {

    static defaultProps = {
        onSuccess: undefined
    };

    constructor(props) {
        super(props);
        this.state = {data: {}};
        this.presenter = new UserPresenter(this);
    }

    componentDidMount() {
        this.presenter.getUser({accountId: this.props.id}, {}, (result) => {
            this.form.setFieldsValue(result.data);
            this.setState({data: result.data, status: result.data.status});
        });
    }

    _closeForm() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    _onSubmit() {
        this.form.validateFields().then(values => {
            this.showDoingIndicator('处理中');
            this.presenter.modifyStatus({accountId: this.props.id, ...values}, {}, () => {
                this.noticeSuccess("修改成功");
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            });
        });
    }

    showLoadingIndicator(text) {
        this.showSpin(text);
    }

    closeLoadingIndicator() {
        this.closeSpin();
    }

    showDoingIndicator(text) {
        this.showSpin(text);
    }

    closeDoingIndicator() {
        this.closeSpin();
    }

    render() {
        const formItemLayout = {
            labelCol: {
                span: 4
            },
            wrapperCol: {
                span: 20
            },
        };
        return this.renderSpin(
            <Form ref={(o) => this.form = o} className="form" {...formItemLayout}>
                <Form.Item label="状态" name="status"
                           rules={[{required: true, message: '请选择状态'}]}>
                    <Select onChange={(value) => {
                        this.setState({status: value});
                    }}>
                        <Select.Option value={0}>正常</Select.Option>
                        <Select.Option value={1}>注销</Select.Option>
                        <Select.Option value={2}>锁定</Select.Option>
                    </Select>
                </Form.Item>
                {
                    this.state.status === 0 ? (
                        <Form.Item label="描述" name="statusMsg">
                            <Input.TextArea placeholder="请输入状态描述"/>
                        </Form.Item>
                    ) : (
                        <Form.Item label="描述" name="statusMsg" rules={[{required: true, message: '请输入状态描述'}]}>
                            <Input.TextArea placeholder="请输入状态描述"/>
                        </Form.Item>
                    )
                }
                <Row type="flex" justify="end">
                    <Col>
                        <Button onClick={this._closeForm.bind(this)}>
                            取消
                        </Button>
                    </Col>
                    <Col offset={1}>
                        <Button type="primary" onClick={this._onSubmit.bind(this)}>
                            保存
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}
